module.exports = __webpack_public_path__ + "img/dominos-logo.c9b1ca5e.png";